
import * as React from 'react';


const AngryFace = ({
  style,
  className,
  size = '30px',
  color = '#333' }) => /*#__PURE__*/

React.createElement("svg", {
  fill: "none",
  width: size,
  height: size,
  style: style,
  viewBox: "0 0 30 31",
  className: className,
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

React.createElement("g", { clipPath: "url(#clip0_9146_54)" }, /*#__PURE__*/
React.createElement("path", {
  d: "M19.83 14.5604C20.9732 14.5604 21.9 13.6336 21.9 12.4904C21.9 11.7978 21.5599 11.1847 21.0375 10.8089L22.2348 9.61158L20.2832 7.65996L16.38 11.5632L17.8254 13.0086C18.0554 13.901 18.8657 14.5604 19.83 14.5604Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  d: "M20.1264 18.0982C21.1788 19.2134 21.6947 20.4691 21.8588 21.1257L19.1812 21.7951C19.1154 21.5317 18.8032 20.7174 18.1191 19.9925C17.4722 19.307 16.4983 18.7004 15 18.7004C13.5017 18.7004 12.5279 19.307 11.8809 19.9926C11.1968 20.7174 10.8847 21.5317 10.8188 21.7951L8.14122 21.1257C8.30536 20.4691 8.8212 19.2134 9.87363 18.0982C10.9632 16.9437 12.6343 15.9404 15 15.9404C17.3657 15.9404 19.0369 16.9437 20.1264 18.0982Z",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  d: "M1.2 15.9404C1.2 8.31885 7.37847 2.14038 15 2.14038C22.6215 2.14038 28.8 8.31885 28.8 15.9404C28.8 23.5619 22.6215 29.7404 15 29.7404C7.37847 29.7404 1.2 23.5619 1.2 15.9404ZM15 4.90038C8.90277 4.90038 3.96 9.84316 3.96 15.9404C3.96 22.0376 8.90277 26.9804 15 26.9804C21.0972 26.9804 26.04 22.0376 26.04 15.9404C26.04 9.84316 21.0972 4.90038 15 4.90038Z",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: color }), /*#__PURE__*/

React.createElement("path", {
  d: "M10.5461 14.5604C9.40283 14.5604 8.47606 13.6336 8.47606 12.4904C8.47606 11.7978 8.81619 11.1847 9.33853 10.8089L8.14122 9.61158L10.0928 7.65996L13.9961 11.5632L12.5507 13.0086C12.3206 13.901 11.5103 14.5604 10.5461 14.5604Z",
  fill: color })), /*#__PURE__*/


React.createElement("defs", null, /*#__PURE__*/
React.createElement("clipPath", { id: "clip0_9146_54" }, /*#__PURE__*/
React.createElement("rect", { width: "30", height: "30", fill: "white", transform: "translate(0 0.940369)" }))));





export default AngryFace;